import { Observable } from "rxjs";
import { ParcelType } from "@app/business/business-models";

export interface IParcelTypeOptions {
    type: ParcelType | 'ALL';
    textToVisualize: Observable<string>;
}

export enum ParcelStatus {
    ALL = 'ALL', // used for the UI visualization it's removed before sending to the server
    // regular status
    IN_PROGRESS = 'IN_PROGRESS',
    SIGNED = 'SIGNED',
    SIGNING = 'SIGNING',
    RECEIVED = 'RECEIVED',
    REJECTED = 'REJECTED',
    REVOKED = 'REVOKED',
    ARCHIVED = 'ARCHIVED',
    DELETED = 'DELETED',
    EXPIRED = 'EXPIRED',
    // registered mail status
    PENDING = 'PENDING',
    SENT = 'SENT',
    DELIVERED = 'DELIVERED',
    VIEWED = 'VIEWED',
    FAILED = 'FAILED',
}

export interface IStatusesAndLabelsForParcel {
    status: ParcelStatus;
    textToVisualize: Observable<string>;
}

export interface IParamsForReceiptRequest {
    messageIdentifier: string;
    responseType: ReceiptParamsType;
    responseFormat: ReceiptParamsFormat;
}

export enum ReceiptParamsType {
    PDF = 'PDF'
}

export enum ReceiptParamsFormat {
    SHORT = 'SHORT'
}